/* eslint-disable react/display-name */
import classNames from 'classnames';
import React, { useRef } from 'react';
import './TextLabel.client.css';
export const TextLabel = (props) => {
  const show = typeof props.show === 'boolean' ? props.show : true;
  const contenrEditableRef = useRef(null);

  return show && <TextLabelInteral {...props} pref={contenrEditableRef} />;
};

const TextLabelInteral = React.memo(
  (props) => {
    if (!props?.field) {
      console.error('Error in TextLabel component, props.field is undefined');
      return;
    }
    const { text, id, fontSize, fontWeight } = props.field;
    const { textType, outlineSelector } = props;

    const tag = props.tag;
    const stylesObject = {
      fontSize: fontSize,
      fontWeight,
      //color: colorMapper[textType] || colorMapper["body"],
      //fontFamily: fontMapper[textType] || fontMapper["body"],
    };

    const isHTML = (str) => {
      const htmlRegex = /<[^>]+>/g;
      return htmlRegex.test(str);
    };

    function generateHTML(tag, text) {
      switch (tag) {
        case 'h1':
          return `<h1>${text}</h1>`;
        case 'h2':
          return `<h2>${text}</h2>`;
        case 'h3':
          return `<h3>${text}</h3>`;
        case 'p1':
          return `<p class="text-2xl">${text}</p>`;
        case 'p2':
          return `<p class="text-xl">${text}</p>`;
        case 'p3':
          return `<p>${text}</p>`;
        case 'p4':
          return `<p class="text-sm">${text}</p>`;
        case 'p1Bold':
          return `<p style="font-weight:700" class="text-2xl">${text}</p>`;
        case 'p2Bold':
          return `<p style="font-weight:700" class="text-xl">${text}</p>`;
        case 'p3Bold':
          return `<p style="font-weight:700" ">${text}</p>`;
        case 'p4Bold':
          return `<p style="font-weight:700" class="text-sm">${text}</p>`;
        default:
          return tag ? `<${tag}>${text}</${tag}>` : text;
      }
    }

    const _text = isHTML(text) ? text : generateHTML(tag, text);

    switch (tag) {
      default:
        return (
          <div
            style={stylesObject}
            ref={props.pref}
            className={classNames(props.className, props?.field?.class, 'text-label', {
              [textType]: textType,
            })}
            data-key={'text'}
            data-id={id}
            data-outline={outlineSelector}
            dangerouslySetInnerHTML={{ __html: _text }}
          ></div>
        );
    }
  },
  (prevProps, nextProps) => {
    /* const isInputFocused = () => {
      const id = nextProps?.field?.id;
      if (id) {
        const divElement = document?.getElementById(id);

        if (divElement) {
          const inputElement = divElement?.querySelector(
            'input[type="text"][name="text"]'
          );
          return inputElement === document.activeElement;
        }
        return false;
      }
    }; */

    const isTipTapActive =
      document
        ?.getElementById('contentIframe')
        ?.contentWindow.document.querySelector(`[data-id="${nextProps?.field?.id}"]`)?.firstChild?.contentEditable ===
      'true'
        ? true
        : false;
    return isTipTapActive;
  },
);
